module.exports = __webpack_public_path__ + "thumbnail-4c17fb2f931d448f06233704c3ca091e.png";